// extracted by mini-css-extract-plugin
var _1 = "RequestEditUserCommentFields-modulefield__MoLTp";
var _2 = "RequestEditUserCommentFields-moduletextarea__xNoVP";
export { _1 as "field", _2 as "textarea" }
